import { render, staticRenderFns } from "./SegmentSelection.vue?vue&type=template&id=204bef3e&scoped=true&"
import script from "./SegmentSelection.vue?vue&type=script&lang=js&"
export * from "./SegmentSelection.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSelection.vue?vue&type=style&index=0&id=204bef3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204bef3e",
  null
  
)

export default component.exports